import angular from "angular";
import {
  vsComponentName as machineDetailConfigurationComponentName,
  machineDetailConfigurationComponentOptions,
} from "./components/machineDetailConfiguration";

import {
  vsComponentName as progressiveDefinitionMachinesViewComponentName,
  progressiveDefinitionMachinesViewComponentOptions,
} from "./components/definitionMachines";

import {
  vsComponentName as progressiveDefinitionMachinesEditViewComponentName,
  progressiveDefinitionMachinesEditViewComponentOptions,
} from "./components/definitionMachines/edit";
import { progressiveDefinitionMachineConfig } from "./configs/progressiveDefinitionMachine";
import {
  ProgressiveModuleConfigurationServiceProvider,
  vsProviderName as ProgressiveModuleConfigurationServiceProviderName,
} from "../machines.progressives/progressiveModuleConfigurationService";
import { machineDetailTabsConfig } from "./registration/machineDetailTabsConfig";
import {
  ProgressiveComponentsModuleConfig,
  vsConfigName,
} from "./moduleConfig";

import {
  vsComponentName as machineProgressiveMeterReadingComponentName,
  machineDetailProgressiveMeterReadingsComponentOptions,
} from "../machines/common/Pages/detail/progressiveMeterReadings";

const vsModuleName = "machines.progressives.components";

export function registerProgressiveComponents(
  config?: ProgressiveComponentsModuleConfig
) {
  const defaultConfig: ProgressiveComponentsModuleConfig = {
    allowMachineEdit: true,
    progressiveDefinitionMachinesViewComponentName,
    progressiveDefinitionMachinesEditViewComponentName,
  };

  const effectiveConfig: ProgressiveComponentsModuleConfig = {
    ...defaultConfig,
    ...config,
  };

  angular
    .module(
      vsModuleName,
      ["SlotTrak.Machines.Progressives"],
      [
        ProgressiveModuleConfigurationServiceProviderName,
        (
          progressiveModuleConfigurationServiceProvider: ProgressiveModuleConfigurationServiceProvider
        ) => {
          progressiveModuleConfigurationServiceProvider.progressiveMachinesComponentName =
            effectiveConfig.progressiveDefinitionMachinesViewComponentName!;
          progressiveModuleConfigurationServiceProvider.progressiveMachinesEditMachineComponentName =
            effectiveConfig.progressiveDefinitionMachinesEditViewComponentName!;

          progressiveModuleConfigurationServiceProvider.progressiveDefinitionMachinesFetcher =
            (serverUtility, progressiveDefinition) =>
              serverUtility.fetchAllWrapped({
                url: "/api/machines/progressives/ProgressiveDefinitionMachine/structured",
                query: {
                  ProgressiveDefinitionId: progressiveDefinition.Id,
                  Fields: "Id,MachineConfigurationId",
                },
              });
        },
      ]
    )
    .value(vsConfigName, effectiveConfig)
    .component(
      machineDetailConfigurationComponentName,
      machineDetailConfigurationComponentOptions
    )
    .component(
      progressiveDefinitionMachinesViewComponentName,
      progressiveDefinitionMachinesViewComponentOptions
    )
    .component(
      progressiveDefinitionMachinesEditViewComponentName,
      progressiveDefinitionMachinesEditViewComponentOptions
    )
    .component(
      machineProgressiveMeterReadingComponentName,
      machineDetailProgressiveMeterReadingsComponentOptions
    )
    .config(progressiveDefinitionMachineConfig)
    .config(machineDetailTabsConfig());

  return vsModuleName;
}

// angular
//   .module(vsModuleName, [])
//   .component(
//     machineDetailConfigurationComponentName,
//     machineDetailConfigurationComponentOptions
//   )
//   .component(
//     progressiveDefinitionMachinesViewComponentName,
//     progressiveDefinitionMachinesViewComponentOptions
//   )
//   .config(progressiveDefinitionMachineConfig);
